module.exports = __webpack_public_path__ + "static/media/tms_junior_logo.c0b2a254.png";